import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import VehicleVisualModelView, { VehicleVisualModelViewProps } from "./VehicleVisualModelView";

type Props = {
  viewProps: VehicleVisualModelViewProps;
} & AppModalProps;

export function VehicleVisualModelViewModal({ viewProps, ...dialogProps }: Props) {
  const openStatus = useModalOpenStatus(dialogProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <VehicleVisualModelView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              ...viewProps?.displayProps,
            }}
            onClose={() => {
              dialogProps.onClose && dialogProps.onClose({}, "backdropClick");
              viewProps.onClose && viewProps.onClose();
            }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
